// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { GetTaxExemptionCertificatesApiParameter } from "@store/Framework/Services/TaxExemptionCertificatesService";
import TaxExemptionCertificatesState from "@store/Framework/Store/Greif/Pages/TaxExemptionCertificates/TaxExemptionCertificatesState";
import { Draft } from "immer";

const initialState: TaxExemptionCertificatesState = {
    getTaxExemptionCertificatesParameter: {
        sort: "state ASC",
    },
};

const actions = {
    "Grefi/Pages/TaxExemptionCertificates/UpdateSearchFields": (
        draft: Draft<TaxExemptionCertificatesState>,
        action: { parameter: GetTaxExemptionCertificatesApiParameter & UpdateSearchFieldsType },
    ) => {
        const { type } = action.parameter;
        delete action.parameter.type;
        if (type === "Replace") {
            draft.getTaxExemptionCertificatesParameter = action.parameter;
        } else if (type === "Initialize") {
            draft.getTaxExemptionCertificatesParameter = {
                ...initialState.getTaxExemptionCertificatesParameter,
                ...action.parameter,
            };
        } else {
            draft.getTaxExemptionCertificatesParameter = {
                ...draft.getTaxExemptionCertificatesParameter,
                ...action.parameter,
            };

            for (const key in draft.getTaxExemptionCertificatesParameter) {
                const value = (<any>draft.getTaxExemptionCertificatesParameter)[key];

                // remove empty parameters
                if (value === "" || value === undefined) {
                    delete (<any>draft.getTaxExemptionCertificatesParameter)[key];
                }
            }

            for (const key in action.parameter) {
                // go back to page 1 if any other parameters changed
                if (
                    draft.getTaxExemptionCertificatesParameter.page &&
                    draft.getTaxExemptionCertificatesParameter.page > 1 &&
                    key !== "page" &&
                    key !== "pageSize"
                ) {
                    draft.getTaxExemptionCertificatesParameter.page = 1;
                }
            }
        }
    },
    "Grefi/Pages/TaxExemptionCertificates/ClearParameter": (draft: Draft<TaxExemptionCertificatesState>) => {
        draft.getTaxExemptionCertificatesParameter = {
            ...initialState.getTaxExemptionCertificatesParameter,
            pageSize: draft.getTaxExemptionCertificatesParameter.pageSize,
        };
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifTaxExemptionCertificatesPagesActions = Parameters<typeof reducer>[1];
export default reducer;
